export default __webpack_public_path__ + "static/media/pdf_icon.2d89fbec.svg";